import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styleUrls: ['./toolbar-user.component.scss']
})
export class ToolbarUserComponent implements OnInit {

  isOpen: boolean;

  constructor() { }
  name: string;
  photo: string;

  ngOnInit() {
    this.name = localStorage.getItem('first_name');
    this.photo = localStorage.getItem('userphoto');
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onClickOutside() {
    this.isOpen = false;
  }

}
